/* eslint-disable import/no-anonymous-default-export */
import welcomePage from "./welcome-page.json"

export default {
  "welcome-page": welcomePage,
}
